import { render } from "./iconValidation.vue?vue&type=template&id=96e21390"
import script from "./iconValidation.vue?vue&type=script&lang=js"
export * from "./iconValidation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__